import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import {
  fetchBrowseDivisions,
  fetchBrowseDepartments,
  fetchBrowseCalendars,
  fetchBrowseCalendarEvents,
  fetchBrowsePlans,
  type BrowsePlansParams,
} from '@/api/planBrowse'

export function useBrowseDivisions(q?: string) {
  return useQuery({
    queryKey: queryKeys.browse.divisions(q),
    queryFn: () => fetchBrowseDivisions({ q }),
  })
}

export function useBrowseDepartments(divisionId: string, q?: string) {
  return useQuery({
    queryKey: queryKeys.browse.departments(divisionId, q),
    queryFn: () => fetchBrowseDepartments(divisionId, { q }),
    enabled: !!divisionId,
  })
}

export function useBrowseCalendars(departmentId: string | null) {
  return useQuery({
    queryKey: queryKeys.browse.calendars(departmentId!),
    queryFn: () => fetchBrowseCalendars(departmentId!),
    enabled: !!departmentId,
  })
}

export function useBrowseCalendarEvents(
  departmentId: string | null,
  calendarId: string | null
) {
  return useQuery({
    queryKey: queryKeys.browse.calendarEvents(departmentId!, calendarId!),
    queryFn: () => fetchBrowseCalendarEvents(departmentId!, calendarId!),
    enabled: !!departmentId && !!calendarId,
  })
}

export function useBrowsePlans(filters: BrowsePlansParams | null) {
  return useQuery({
    queryKey: queryKeys.browse.plans(
      (filters as unknown as Record<string, unknown>) ?? {}
    ),
    queryFn: () => fetchBrowsePlans(filters!),
    enabled: !!filters?.departmentId,
  })
}
